module.exports = __webpack_public_path__ + "static/media/22ESCWA21.f1a9f4f6.jpg";